type Option = {
  value: string;
  text: string;
};

const contactForm = (): void => {
  // Define available regions for each product
  const optionsByProduct: Record<string, Option[]> = {
    '18F-FET (TLX101-CDx)': [
      { value: 'US', text: 'US' },
      { value: 'EMEA', text: 'EMEA' },
    ],
    '68Ga-PSMA-11/Illuccix (TLX591-CDx)': [
      { value: 'EMEA', text: 'EMEA' },
      { value: 'CA', text: 'CA' },
    ],
    '89Zr-DFO-girentuximab (TLX250-CDx)': [
      { value: 'US', text: 'US' },
      { value: 'EMEA', text: 'EMEA' },
      { value: 'APAC', text: 'APAC' },
      { value: 'CA', text: 'CA' },
    ],
    '177Lu-DOTA-girentuximab (TLX250)': [{ value: 'APAC', text: 'APAC' }],
    '131I-IPA (TLX101)': [
      { value: 'US', text: 'US' },
      { value: 'EMEA', text: 'EMEA' },
      { value: 'APAC', text: 'APAC' },
    ],
    Default: [
      { value: 'US', text: 'US' },
      { value: 'EMEA', text: 'EMEA' },
      { value: 'APAC', text: 'APAC' },
      { value: 'CA', text: 'CA' },
    ],
  };

  const updateRegionOptions = (selectedProduct: string): void => {
    const regionSelect = document.getElementById(
      'region-select'
    ) as HTMLSelectElement | null;
    if (!regionSelect) return;

    regionSelect.innerHTML = '';
    const defaultOption = document.createElement('option');
    defaultOption.value = '';
    defaultOption.text = '—Please choose an option—';
    regionSelect.appendChild(defaultOption);

    const options =
      optionsByProduct[selectedProduct] || optionsByProduct['Default'];
    options.forEach((opt) => {
      const option = document.createElement('option');
      option.value = opt.value;
      option.text = opt.text;
      regionSelect.appendChild(option);
    });
  };

  const handleUserTypeChange = (userType: string): void => {
    const institutionField = document.getElementById(
      'institution-field'
    ) as HTMLInputElement | null;
    const compoundSelect = document.getElementById(
      'compound-select'
    ) as HTMLSelectElement | null;
    const regionSelect = document.getElementById(
      'region-select'
    ) as HTMLSelectElement | null;

    if (!institutionField || !compoundSelect || !regionSelect) return;

    if (userType === 'Patient') {
      institutionField.placeholder = 'City';
      compoundSelect.innerHTML = '';
      regionSelect.innerHTML = '';

      const patientOption = document.createElement('option');
      patientOption.value = '89Zr-DFO-girentuximab (TLX250-CDx)';
      patientOption.text = '89Zr-DFO-girentuximab (TLX250-CDx)';
      compoundSelect.appendChild(patientOption);

      const regionOption = document.createElement('option');
      regionOption.value = 'US';
      regionOption.text = 'US';
      regionSelect.appendChild(regionOption);
    } else {
      institutionField.placeholder = 'Institution Name';
      compoundSelect.innerHTML = '';
      const defaultCompounds = [
        '18F-FET (TLX101-CDx)',
        '68Ga-PSMA-11/Illuccix (TLX591-CDx)',
        '89Zr-DFO-girentuximab (TLX250-CDx)',
        '177Lu-DOTA-girentuximab (TLX250)',
        '131I-IPA (TLX101)',
      ];
      defaultCompounds.forEach((compound) => {
        const option = document.createElement('option');
        option.value = compound;
        option.text = compound;
        compoundSelect.appendChild(option);
      });
      updateRegionOptions(defaultCompounds[0]);
    }
  };

  const userTypeSelect = document.getElementById('user-type-select');
  const compoundSelect = document.getElementById('compound-select');

  userTypeSelect?.addEventListener('change', (event) => {
    const target = event.target as HTMLSelectElement;
    handleUserTypeChange(target.value);
  });

  compoundSelect?.addEventListener('change', (event) => {
    const target = event.target as HTMLSelectElement;
    updateRegionOptions(target.value);
  });
  // script functionality for form toggle and response output
  const contactFormToggle = document.querySelector(
    '.contact-form--toggle'
  ) as HTMLElement | null;
  if (contactFormToggle) {
    const formButton = document.getElementById(
      'form-button'
    ) as HTMLElement | null;
    const formContainer = formButton
      ?.closest('.contact-form')
      ?.querySelector('.contact-form__container form') as HTMLElement | null;

    if (formButton && formContainer) {
      formButton.addEventListener('click', function (e) {
        e.preventDefault();
        if (formContainer.classList.contains('contact-form__container--hide')) {
          formContainer.style.maxHeight = null;
        } else {
          formContainer.style.maxHeight = formContainer.scrollHeight + 'px';
        }
        formContainer.classList.toggle('contact-form__container--hide');
      });
    }

    const wpcf7Response = document.querySelector(
      '.wpcf7-response-output'
    ) as HTMLElement | null;
    if (wpcf7Response) {
      const wpcf7ResponseContent = wpcf7Response.innerHTML;
      if (wpcf7ResponseContent) {
        formContainer.style.maxHeight = formContainer.scrollHeight + 'px';
      }
    }
  }
};

export default contactForm;
